import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  const [activeSection, setActiveSection] = useState(null);

  // Function to toggle section visibility
  const toggleSection = (sectionId) => {
    setActiveSection(activeSection === sectionId ? null : sectionId);
  };

  return (
    <div className="privacy-policy">
      <div className="container">
        <div className="privacy-header">
          <h1>
            {t(
              "privacy_policy_title",
              'سياسة الخصوصية لتطبيق ومتجر "متجر الحرم"'
            )}
          </h1>
          <div className="privacy-contact-info">
            <p>
              {t("website", "الموقع الإلكتروني")}:{" "}
              <a
                href="https://matjaralharam.sa"
                target="_blank"
                rel="noopener noreferrer"
              >
                matjaralharam.sa
              </a>
            </p>
            <p>
              {t("email", "البريد الإلكتروني")}:{" "}
              <a href="mailto:matjaralharam@gmail.com">
                matjaralharam@gmail.com
              </a>
            </p>
            <p>
              {t("location", "الموقع")}:{" "}
              {t("location_value", "مكة المكرمة – المملكة العربية السعودية")}
            </p>
          </div>
          <p className="privacy-intro">
            {t(
              "privacy_intro",
              'تقدّم لكم هذه الوثيقة سياسة الخصوصية ("السياسة") الخاصة باستخدام تطبيق "متجر الحرم" والموقع الإلكتروني (يُشار إليهما مجتمعين أو منفصلين بـ "التطبيق" أو "الخدمة" أو "منصة متجر الحرم"). وُضعت هذه السياسة التزامًا منا باحترام خصوصية مستخدمي ومزودي الخدمة وحماية بياناتهم الشخصية، ووفقًا للأنظمة المعمول بها في المملكة العربية السعودية بما فيها نظام التجارة الإلكترونية ولائحته التنفيذية، ونظام حماية البيانات الشخصية (عند بدء نفاذه). برجاء قراءة هذه السياسة بعناية لفهم كيفية جمعنا للبيانات واستخدامها ومشاركتها.'
            )}
          </p>
        </div>

        <div className="privacy-sections">
          {/* Section 1: Policy Scope */}
          <div className="privacy-section">
            <h2
              onClick={() => toggleSection("scope")}
              className="section-title"
            >
              <span>{t("policy_scope_title", "أولاً: نطاق السياسة")}</span>
              <span className="toggle-icon">
                {activeSection === "scope" ? "−" : "+"}
              </span>
            </h2>
            <div
              className={`section-content ${
                activeSection === "scope" ? "active" : ""
              }`}
            >
              <h3>{t("acceptance_title", "قبول السياسة")}</h3>
              <p>
                {t(
                  "acceptance_content",
                  "باستخدامك لتطبيق ومتجر الحرم، أو تصفّحك لموقعنا الإلكتروني أو تزويدنا بأي من معلوماتك الشخصية، فإنك تقرّ بموافقتك على كافة البنود الواردة في هذه السياسة."
                )}
              </p>

              <h3>{t("updates_title", "تحديث السياسة")}</h3>
              <p>
                {t(
                  "updates_content",
                  "قد نقوم بتعديل أو تحديث بنود هذه السياسة من وقتٍ لآخر؛ لذا نحثّك على الاطّلاع عليها دوريًا. استمرارك في استخدام الخدمات بعد نشر أي تعديلات يعني موافقتك على تلك التعديلات."
                )}
              </p>
            </div>
          </div>

          {/* Section 2: Information We Collect */}
          <div className="privacy-section">
            <h2
              onClick={() => toggleSection("collection")}
              className="section-title"
            >
              <span>
                {t("info_collection_title", "ثانيًا: المعلومات التي نجمعها")}
              </span>
              <span className="toggle-icon">
                {activeSection === "collection" ? "−" : "+"}
              </span>
            </h2>
            <div
              className={`section-content ${
                activeSection === "collection" ? "active" : ""
              }`}
            >
              <h3>{t("personal_info_title", "المعلومات الشخصية")}</h3>
              <p>
                {t(
                  "personal_info_content1",
                  "قد نقوم بجمع معلومات التواصل الأساسية مثل الاسم، ورقم الجوال، وعنوان البريد الإلكتروني، وعنوان الإقامة أو الشحن، وغيرها من المعلومات اللازمة للتسجيل أو إتمام الخدمات."
                )}
              </p>
              <p>
                {t(
                  "personal_info_content2",
                  "عند استخدام مزوّد الخدمة للمنصة، قد نطلب معلومات تتعلق بالهوية الرسمية أو سجل المنشأة أو التراخيص اللازمة لممارسة نشاطه التجاري (في حال كان مزوّد خدمة)."
                )}
              </p>

              <h3>{t("technical_info_title", "المعلومات التقنية")}</h3>
              <p>
                {t(
                  "technical_info_content",
                  "نقوم بجمع بعض المعلومات التقنية ذات الصلة بجهازك ونظام التشغيل ونسخة التطبيق، وتاريخ ووقت تسجيل الدخول، وعنوان بروتوكول الإنترنت (IP)، ونوع المتصفح، وملفات تعريف الارتباط (Cookies)، وتقنيات مشابهة تسهّل تجربة المستخدم وتحسّن من أداء المنصة."
                )}
              </p>

              <h3>{t("payment_info_title", "معلومات الدفع")}</h3>
              <p>
                {t(
                  "payment_info_content",
                  "عند تنفيذ معاملات الشراء أو الطلبات، قد نجمع البيانات المالية اللازمة كرقم البطاقة الائتمانية أو معلومات الحساب البنكي أو وسائل الدفع الأخرى، وذلك لضمان معالجة الدفعات واستكمالها. علمًا بأن هذه المعلومات تُعالج بشكل آمن بالتعاون مع مزوّدي خدمات الدفع المرخَّص لهم في المملكة العربية السعودية."
                )}
              </p>

              <h3>{t("other_info_title", "معلومات أخرى")}</h3>
              <p>
                {t(
                  "other_info_content",
                  "أي معلومات إضافية تختار مشاركتها معنا من خلال رسائل البريد الإلكتروني، أو نماذج الاتصال، أو المحادثات الفورية، أو استطلاعات الرأي، أو غيرها من الوسائل."
                )}
              </p>
            </div>
          </div>

          {/* Section 3: How We Use Information */}
          <div className="privacy-section">
            <h2
              onClick={() => toggleSection("usage")}
              className="section-title"
            >
              <span>
                {t("info_usage_title", "ثالثًا: كيفية استخدامنا للمعلومات")}
              </span>
              <span className="toggle-icon">
                {activeSection === "usage" ? "−" : "+"}
              </span>
            </h2>
            <div
              className={`section-content ${
                activeSection === "usage" ? "active" : ""
              }`}
            >
              <h3>
                {t("service_provision_title", "تقديم الخدمات وتنفيذ الطلبات")}
              </h3>
              <p>
                {t(
                  "service_provision_content",
                  "استخدام المعلومات للتواصل معك، والتحقّق من هويتك، وإتمام المعاملات والدفع، وضمان تسليم المنتجات أو الخدمات المطلوبة، والرد على الاستفسارات والشكاوى."
                )}
              </p>

              <h3>
                {t("quality_improvement_title", "تحسين الجودة وتطوير الخدمات")}
              </h3>
              <p>
                {t(
                  "quality_improvement_content",
                  "نسعى إلى تحسين تجربتك والخدمات المقدّمة من خلال تحليل سلوك المستخدمين وملاحظاتهم، وإجراء الدراسات والأبحاث الداخلية، وتطوير مزايا جديدة في التطبيق."
                )}
              </p>

              <h3>{t("marketing_title", "التسويق والترويج")}</h3>
              <p>
                {t(
                  "marketing_content",
                  "قد نستخدم معلوماتك للتواصل معك فيما يخص العروض الترويجية أو الإعلانات أو الحملات التسويقية الخاصة بنا، شريطة موافقتك المسبقة (عند الاقتضاء)، وبما يتوافق مع الأنظمة السعودية ذات العلاقة."
                )}
              </p>

              <h3>{t("compliance_title", "الامتثال للنظام والقانون")}</h3>
              <p>
                {t(
                  "compliance_content",
                  "نحتفظ بالحق في الكشف عن معلومات المستخدم في حال طلب ذلك من قِبل الجهات المختصة أو تنفيذًا لأمر قضائي أو للامتثال لأي التزام قانوني في المملكة العربية السعودية، وبما يحمي حقوقنا أو حقوق الغير."
                )}
              </p>
            </div>
          </div>

          {/* Section 4: Data Protection */}
          <div className="privacy-section">
            <h2
              onClick={() => toggleSection("protection")}
              className="section-title"
            >
              <span>
                {t(
                  "data_protection_title",
                  "رابعًا: حماية البيانات وأمن المعلومات"
                )}
              </span>
              <span className="toggle-icon">
                {activeSection === "protection" ? "−" : "+"}
              </span>
            </h2>
            <div
              className={`section-content ${
                activeSection === "protection" ? "active" : ""
              }`}
            >
              <h3>{t("security_measures_title", "التدابير الأمنية")}</h3>
              <p>
                {t(
                  "security_measures_content1",
                  "نعتمد على إجراءات وتقنيات أمان متقدّمة لحماية معلومات المستخدمين من الوصول غير المصرح به أو التعديل أو الإفشاء أو الإتلاف."
                )}
              </p>
              <p>
                {t(
                  "security_measures_content2",
                  "نحرص على تشفير المعاملات المالية وحفظ سجلات الدفع ضمن أنظمة مخصّصة وآمنة."
                )}
              </p>

              <h3>{t("access_limitation_title", "محدودية الوصول")}</h3>
              <p>
                {t(
                  "access_limitation_content",
                  "يقتصر الوصول إلى بيانات المستخدمين على الموظفين والمزودين المعنيين بإتمام وتنفيذ الخدمات، والذين يلتزمون تعاقديًا بالحفاظ على سرية البيانات."
                )}
              </p>

              <h3>{t("data_storage_title", "التخزين والاحتفاظ بالبيانات")}</h3>
              <p>
                {t(
                  "data_storage_content",
                  "سنحتفظ بمعلوماتك الشخصية طوال الفترة اللازمة لتحقيق الأغراض المحددة في هذه السياسة أو حسب المدد المطلوبة بموجب الأنظمة المعمول بها."
                )}
              </p>
            </div>
          </div>

          {/* Section 5: Data Sharing */}
          <div className="privacy-section">
            <h2
              onClick={() => toggleSection("sharing")}
              className="section-title"
            >
              <span>
                {t(
                  "data_sharing_title",
                  "خامسًا: مشاركة البيانات مع أطراف ثالثة"
                )}
              </span>
              <span className="toggle-icon">
                {activeSection === "sharing" ? "−" : "+"}
              </span>
            </h2>
            <div
              className={`section-content ${
                activeSection === "sharing" ? "active" : ""
              }`}
            >
              <h3>
                {t("service_providers_title", "مزوّدو الخدمة والشركات التابعة")}
              </h3>
              <p>
                {t(
                  "service_providers_content",
                  "قد نشارك بياناتك مع مزوّدي الخدمة المتعاونين معنا، مثل شركات الشحن أو المزودين المشاركين في إنجاز المعاملات، شريطة التزامهم بالمحافظة على سريّة بياناتك."
                )}
              </p>

              <h3>{t("external_links_title", "الروابط والمواقع الخارجية")}</h3>
              <p>
                {t(
                  "external_links_content",
                  "قد يحتوي تطبيقنا أو موقعنا على روابط لمواقع وتطبيقات خارجية. لا نتحمل مسؤولية سياسات الخصوصية لتلك المواقع، لذا يُرجى مراجعتها عند زيارتها."
                )}
              </p>

              <h3>{t("legal_requirements_title", "المقتضيات القانونية")}</h3>
              <p>
                {t(
                  "legal_requirements_content",
                  "قد نكشف عن معلوماتك التزامًا بأمر قضائي، أو توجيه حكومي أو نظامي، أو في حال الدفاع عن حقوقنا أو حماية حقوق مستخدمينا."
                )}
              </p>
            </div>
          </div>

          {/* Section 6: Cookies */}
          <div className="privacy-section">
            <h2
              onClick={() => toggleSection("cookies")}
              className="section-title"
            >
              <span>
                {t(
                  "cookies_title",
                  "سادسًا: ملفات تعريف الارتباط (Cookies) والتقنيات المشابهة"
                )}
              </span>
              <span className="toggle-icon">
                {activeSection === "cookies" ? "−" : "+"}
              </span>
            </h2>
            <div
              className={`section-content ${
                activeSection === "cookies" ? "active" : ""
              }`}
            >
              <h3>{t("cookies_what_title", "ماهيتها")}</h3>
              <p>
                {t(
                  "cookies_what_content",
                  "ملفات تعريف الارتباط هي ملفات نصيّة صغيرة تُخزَّن في متصفحك أو على جهازك عند زيارتك موقعنا أو استخدامك التطبيق."
                )}
              </p>

              <h3>{t("cookies_purpose_title", "الغرض منها")}</h3>
              <p>
                {t(
                  "cookies_purpose_content",
                  "نستخدم ملفات تعريف الارتباط والتقنيات المشابهة لفهم كيفية تفاعلك مع خدماتنا ولتخصيص تجربتك وتحسينها، مثل تذكّر تفضيلاتك وإعداداتك."
                )}
              </p>

              <h3>{t("cookies_control_title", "التحكم بها")}</h3>
              <p>
                {t(
                  "cookies_control_content",
                  "يمكنك التحكم في إعدادات ملفات تعريف الارتباط من خلال متصفحك؛ ولكن تعطيلها قد يؤثر سلبًا على بعض ميزات التطبيق أو الخدمات."
                )}
              </p>
            </div>
          </div>

          {/* Section 7: Children's Privacy */}
          <div className="privacy-section">
            <h2
              onClick={() => toggleSection("children")}
              className="section-title"
            >
              <span>
                {t("children_privacy_title", "سابعًا: خصوصية الأطفال")}
              </span>
              <span className="toggle-icon">
                {activeSection === "children" ? "−" : "+"}
              </span>
            </h2>
            <div
              className={`section-content ${
                activeSection === "children" ? "active" : ""
              }`}
            >
              <h3>{t("minors_usage_title", "استخدام القُصّر")}</h3>
              <p>
                {t(
                  "minors_usage_content",
                  'تطبيق "متجر الحرم" ليس موجّهًا بشكل خاص للأطفال دون سن 18 سنة. في حال اكتشفنا جمع بيانات شخصية لقاصر دون موافقة ولي الأمر، سنقوم باتخاذ الإجراءات اللازمة لحذف البيانات.'
                )}
              </p>
            </div>
          </div>

          {/* Section 8: User Rights */}
          <div className="privacy-section">
            <h2
              onClick={() => toggleSection("rights")}
              className="section-title"
            >
              <span>{t("user_rights_title", "ثامنًا: حقوق المستخدمين")}</span>
              <span className="toggle-icon">
                {activeSection === "rights" ? "−" : "+"}
              </span>
            </h2>
            <div
              className={`section-content ${
                activeSection === "rights" ? "active" : ""
              }`}
            >
              <h3>{t("access_update_title", "الوصول والتحديث")}</h3>
              <p>
                {t(
                  "access_update_content",
                  "يمكنك الوصول إلى معلومات حسابك وتحديثها أو تصحيحها في أي وقت من خلال إعدادات الحساب في التطبيق."
                )}
              </p>

              <h3>{t("consent_withdrawal_title", "سحب الموافقة")}</h3>
              <p>
                {t(
                  "consent_withdrawal_content",
                  "لك الحق في سحب موافقتك على معالجة بياناتك الشخصية لأغراض تسويقية في أي وقت، وذلك بالتواصل معنا عبر البريد الإلكتروني أدناه."
                )}
              </p>
            </div>
          </div>

          {/* Section 9: Liability Limits */}
          <div className="privacy-section">
            <h2
              onClick={() => toggleSection("liability")}
              className="section-title"
            >
              <span>
                {t("liability_limits_title", "تاسعًا: حدود المسؤولية")}
              </span>
              <span className="toggle-icon">
                {activeSection === "liability" ? "−" : "+"}
              </span>
            </h2>
            <div
              className={`section-content ${
                activeSection === "liability" ? "active" : ""
              }`}
            >
              <h3>{t("service_usage_title", "استخدامك للخدمة")}</h3>
              <p>
                {t(
                  "service_usage_content",
                  "إن استخدامك للخدمة يقع على مسؤوليتك الكاملة، ولا نتحمّل أي خسائر أو أضرار مباشرة أو غير مباشرة إلا في الحدود التي يقرّها النظام في المملكة العربية السعودية."
                )}
              </p>

              <h3>
                {t("provider_dealings_title", "التعاملات مع مزودي الخدمة")}
              </h3>
              <p>
                {t(
                  "provider_dealings_content",
                  "في حال وجود نزاع أو مشكلة مع مزود خدمة مستقل أو جهة خارجية مرتبطة بتقديم الطلب أو التوصيل أو تنفيذ الخدمة، فإن دورنا يقتصر على تسهيل التواصل بين الأطراف؛ ولا نتحمّل أي مسؤولية قانونية تجاه أي مطالبات ناشئة عن ذلك النزاع."
                )}
              </p>
            </div>
          </div>

          {/* Section 10: Policy Updates */}
          <div className="privacy-section">
            <h2
              onClick={() => toggleSection("updates")}
              className="section-title"
            >
              <span>
                {t("policy_updates_title", "عاشرًا: التعديلات على السياسة")}
              </span>
              <span className="toggle-icon">
                {activeSection === "updates" ? "−" : "+"}
              </span>
            </h2>
            <div
              className={`section-content ${
                activeSection === "updates" ? "active" : ""
              }`}
            >
              <h3>{t("modification_right_title", "حق التعديل")}</h3>
              <p>
                {t(
                  "modification_right_content",
                  "نحتفظ بحقنا في تعديل هذه السياسة أو تحديثها في أي وقت، وستكون نافذة من تاريخ نشرها على موقعنا أو إشعارك بها عبر التطبيق."
                )}
              </p>

              <h3>{t("modifications_notice_title", "إشعار التعديلات")}</h3>
              <p>
                {t(
                  "modifications_notice_content",
                  "في حال أجرينا تعديلات جوهرية على طريقة معالجة بياناتك الشخصية، سنحاول إشعارك بوضوح عبر البريد الإلكتروني المسجل لدينا أو بوضع إشعار بارز على التطبيق."
                )}
              </p>
            </div>
          </div>

          {/* Section 11: Contact Us */}
          <div className="privacy-section">
            <h2
              onClick={() => toggleSection("contact")}
              className="section-title"
            >
              <span>{t("contact_us_title", "حادي عشر: الاتصال بنا")}</span>
              <span className="toggle-icon">
                {activeSection === "contact" ? "−" : "+"}
              </span>
            </h2>
            <div
              className={`section-content ${
                activeSection === "contact" ? "active" : ""
              }`}
            >
              <h3>{t("inquiries_complaints_title", "استفسارات وشكاوى")}</h3>
              <p>
                {t(
                  "inquiries_complaints_content",
                  "إذا كانت لديك أي استفسارات، أو مخاوف، أو شكاوى حول هذه السياسة أو ممارسات الخصوصية لدينا، يُرجى مراسلتنا عبر البريد الإلكتروني:"
                )}
              </p>
              <p>
                <a href="mailto:matjaralharam@gmail.com">
                  matjaralharam@gmail.com
                </a>
              </p>

              <h3>{t("electronic_forms_title", "النماذج الإلكترونية")}</h3>
              <p>
                {t(
                  "electronic_forms_content",
                  'يمكنك أيضًا التواصل معنا عبر صفحة "اتصل بنا" في موقعنا الرسمي:'
                )}
              </p>
              <p>
                <a
                  href="https://matjaralharam.sa"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  matjaralharam.sa
                </a>
              </p>
            </div>
          </div>

          {/* Related Laws */}
          <div className="privacy-section">
            <h2 onClick={() => toggleSection("laws")} className="section-title">
              <span>
                {t("related_laws_title", "المصادر والقوانين ذات الصلة")}
              </span>
              <span className="toggle-icon">
                {activeSection === "laws" ? "−" : "+"}
              </span>
            </h2>
            <div
              className={`section-content ${
                activeSection === "laws" ? "active" : ""
              }`}
            >
              <ul className="laws-list">
                <li>
                  {t(
                    "ecommerce_law",
                    "نظام التجارة الإلكترونية ولائحته التنفيذية في المملكة العربية السعودية."
                  )}
                </li>
                <li>
                  {t(
                    "cyber_crime_law",
                    "نظام الجرائم المعلوماتية في المملكة العربية السعودية."
                  )}
                </li>
                <li>
                  {t(
                    "personal_data_law",
                    "نظام حماية البيانات الشخصية الصادر بالمرسوم الملكي رقم (م/19) تاريخ 9/2/1443هـ (عند سريان نفاذه)."
                  )}
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="privacy-footer">
          <p>
            {t(
              "agreement_note",
              'بتأكيدك على استخدام تطبيق "متجر الحرم" وخدماته المختلفة، فإنك تقرّ وتوافق على هذه السياسة، ونأمل أن تقدم لك تجربة تسوق آمنة ومريحة.'
            )}
          </p>
          <p className="last-update">
            {t("last_update", "آخر تحديث")}: {t("update_date", "مارس 2025")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
